import React from "react";
import "./modal.css";
const Modal = ({ setOpen, project }) => {
  console.log("first",project)
  return (
    <div>
      <div className="modal">
        <div onClick={() => setOpen(false)} className="overlay"></div>
        <div className="content_wrapper">
          <div className="modal-content">
            <h2 className="project_title">{project?.name}</h2>
            <div className="project_images">
              {project?.img.map((item, i) => (
                <div key={i} className="project_image">
                  {project?.is_live === true ? (
                    <a href={project.live_link} target="blank">
                      <img src={item} alt="img" className="img" />
                    </a>
                  ) : (
                    <img src={item} alt="img" className="img" />
                  )}
                </div>
              ))}
            </div>
            <h3 className="about">
              About :{" "}
              <span style={{ textTransform: "capitalize" }}>
                {project?.name}
              </span>
            </h3>
            <ul className="project_details">
              {project?.details.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <h3 className="tech_used">
              Technology used :{" "}
              {project?.tech?.map((item, index) => (
                <span key={index} className="tech">
                  {item}
                </span>
              ))}
            </h3>
            <h3>Github Code</h3>
            {(project?.client || project.server) && (
              <div className="code_wrapper">
                {project?.client && (
                  <a className="code-btn" href={project?.client} target="blank">
                    client site
                  </a>
                )}
                {project?.server && (
                  <a className="code-btn" href={project?.server} target="blank">
                    server site
                  </a>
                )}
              </div>
            )}

            {project?.is_live ? (
              <h3 className="live_link">
                website live link :{" "}
                <a target="blank" href={project?.live_link}>
                  {project?.live_link}
                </a>{" "}
              </h3>
            ) : (
              <h3 className="live_link">
                website live link : {project?.live_link}
              </h3>
            )}

            <button className="close-modal" onClick={() => setOpen(false)}>
              CLOSE
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
